import React from "react";

import "./ArticleFeatureText.scss";

export interface IArticleFeatureText {
  titulo: string;
  paragraph: string;
}

const ArticleFeatureText = (props: IArticleFeatureText) => {
  let { titulo, paragraph } = props;
  return (
    <div className="m-article-feature-text">
      <div className="m-article-feature-text__content featured-box">
        <span>
          <h3>{titulo}</h3>
          <p>
            {paragraph}
          </p>
        </span>
      </div>
    </div>
  );
};

export default ArticleFeatureText;
